import { Routes, Route, Navigate } from 'react-router-dom'
import AuthRoute from './components/AuthRoute'
import DesignLogin from './pages/DesignLogin'
import ToolsLayout from './ToolsLayout'
import PreviewPage from './pages/PreviewPage'
import PackagingPage from './pages/PackagingPage'
import ConvertTool from './pages/tools/ConvertTool'
import BgRemoveTool from './pages/tools/BgRemoveTool'
import CaseReportTool from './pages/tools/CaseReportTool'
import CaseReportBuilder from './pages/tools/CaseReportBuilder'
import StlCleanTool from './pages/tools/StlCleanTool'
import PngToPdfTool from './pages/tools/PngToPdfTool'
import GhScriptTool from './pages/tools/GhScriptTool'
import GhScriptPage from './pages/tools/GhScriptPage'
import { findGhScript } from './ghScripts'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<DesignLogin />} />
      <Route path="/" element={<AuthRoute><ToolsLayout /></AuthRoute>}>
        <Route index element={<PreviewPage />} />
        <Route path="packaging" element={<PackagingPage />} />
        <Route path="convert" element={<ConvertTool />} />
        <Route path="bg-remove" element={<BgRemoveTool />} />
        <Route path="case-report" element={<CaseReportTool />} />
        <Route path="case-report-builder" element={<CaseReportBuilder />} />
        <Route path="stl-clean" element={<StlCleanTool />} />
        <Route path="png-to-pdf" element={<PngToPdfTool />} />
        <Route path="gh-generator" element={<GhScriptTool />} />
        {/* Curated GH library — one route per entry in ghScripts.js. */}} />
        <Route path="gh-perforation" element={<GhScriptPage script={findGhScript('perforation')} />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
